import { render, staticRenderFns } from "./ClientsEditPopup.vue?vue&type=template&id=0d001f40&"
import script from "./ClientsEditPopup.vue?vue&type=script&lang=js&"
export * from "./ClientsEditPopup.vue?vue&type=script&lang=js&"
import style0 from "./ClientsEditPopup.vue?vue&type=style&index=0&id=0d001f40&prod&lang=scss&"
import style1 from "./ClientsEditPopup.vue?vue&type=style&index=1&id=0d001f40&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports